import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import { CellNavigationMode } from '../enums';
import { canEdit } from './columnUtils';
export function isSelectedCellEditable(_ref) {
  var selectedPosition = _ref.selectedPosition,
      columns = _ref.columns,
      rows = _ref.rows,
      onCheckCellIsEditable = _ref.onCheckCellIsEditable;
  var column = columns[selectedPosition.idx];
  var row = rows[selectedPosition.rowIdx];
  var isCellEditable = onCheckCellIsEditable ? onCheckCellIsEditable(Object.assign({
    row: row,
    column: column
  }, selectedPosition)) : true;
  return isCellEditable && canEdit(column, row);
}
export function getNextSelectedCellPosition(_ref2) {
  var cellNavigationMode = _ref2.cellNavigationMode,
      columns = _ref2.columns,
      rowsCount = _ref2.rowsCount,
      nextPosition = _ref2.nextPosition;

  if (cellNavigationMode !== CellNavigationMode.NONE) {
    var idx = nextPosition.idx,
        rowIdx = nextPosition.rowIdx;
    var columnsCount = columns.length;
    var isAfterLastColumn = idx === columnsCount;
    var isBeforeFirstColumn = idx === -1;

    if (isAfterLastColumn) {
      if (cellNavigationMode === CellNavigationMode.CHANGE_ROW) {
        var isLastRow = rowIdx === rowsCount - 1;

        if (!isLastRow) {
          return {
            idx: 0,
            rowIdx: rowIdx + 1
          };
        }
      } else if (cellNavigationMode === CellNavigationMode.LOOP_OVER_ROW) {
        return {
          rowIdx: rowIdx,
          idx: 0
        };
      }
    } else if (isBeforeFirstColumn) {
      if (cellNavigationMode === CellNavigationMode.CHANGE_ROW) {
        var isFirstRow = rowIdx === 0;

        if (!isFirstRow) {
          return {
            rowIdx: rowIdx - 1,
            idx: columnsCount - 1
          };
        }
      } else if (cellNavigationMode === CellNavigationMode.LOOP_OVER_ROW) {
        return {
          rowIdx: rowIdx,
          idx: columnsCount - 1
        };
      }
    }
  }

  return nextPosition;
}
export function canExitGrid(_ref3) {
  var cellNavigationMode = _ref3.cellNavigationMode,
      columns = _ref3.columns,
      rowsCount = _ref3.rowsCount,
      _ref3$selectedPositio = _ref3.selectedPosition,
      rowIdx = _ref3$selectedPositio.rowIdx,
      idx = _ref3$selectedPositio.idx,
      shiftKey = _ref3.shiftKey; // When the cellNavigationMode is 'none' or 'changeRow', you can exit the grid if you're at the first or last cell of the grid
  // When the cellNavigationMode is 'loopOverRow', there is no logical exit point so you can't exit the grid

  if (cellNavigationMode === CellNavigationMode.NONE || cellNavigationMode === CellNavigationMode.CHANGE_ROW) {
    var atLastCellInRow = idx === columns.length - 1;
    var atFirstCellInRow = idx === 0;
    var atLastRow = rowIdx === rowsCount - 1;
    var atFirstRow = rowIdx === 0;
    return shiftKey ? atFirstCellInRow && atFirstRow : atLastCellInRow && atLastRow;
  }

  return false;
}